import { PhoneTreeService } from '@weave/schema-gen-ts/dist/schemas/phone/tree/v1/phone_tree_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaPhoneTreeV1Service = bindHTTP(PhoneTreeService);
